import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.DataImport';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class DataImport extends RpcClass{

    /**
     *  @class DataImport
     *  @alias module:src/server/com/silkplm/rpc/plm/DataImport.DataImport
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param file {File} 
     * @param formClassLong {string} 
     * @param masterId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/plm/WarningAndBugs.WarningAndBugs>}
     */
     importData(file, formClassLong, masterId) {
            return RpcClass.rpcCallMultipart('/rpc/plm/data-import/import-data', [file, formClassLong, masterId]);
    }
    /** 
     * @async
     * @param file {File} 
     * @param seasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/plm/WarningAndBugs.WarningAndBugs>}
     */
     importDataToBudgetingPlanner(file, seasonId) {
            return RpcClass.rpcCallMultipart('/rpc/plm/data-import/import-data-to-budgeting-planner', [file, seasonId]);
    }
    /** 
     * @async
     * @param file {File} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/plm/WarningAndBugs.WarningAndBugs>}
     */
     importDataToBudgetingPlannerPM(file) {
            return RpcClass.rpcCallMultipart('/rpc/plm/data-import/import-data-to-budgeting-planner-p-m', [file]);
    }
    /** 
     * @async
     * @param file {File} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/plm/WarningAndBugs.WarningAndBugs>}
     */
     importDataToComponentIndex(file) {
            return RpcClass.rpcCallMultipart('/rpc/plm/data-import/import-data-to-component-index', [file]);
    }
    /** 
     * @async
     * @param file {File} 
     * @param masterId {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/plm/WarningAndBugs.WarningAndBugs>}
     */
     importDataToOrderDetailsPackage(file, masterId) {
            return RpcClass.rpcCallMultipart('/rpc/plm/data-import/import-data-to-order-details-package', [file, masterId]);
    }
    /** 
     * @async
     * @param file {File} 
     * @param operationType {string} 
     * @param updateProductsInSeasonData {boolean} 
     * @param seasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/plm/WarningAndBugs.WarningAndBugs>}
     */
     importDataToProducts(file, operationType, updateProductsInSeasonData, seasonId) {
            return RpcClass.rpcCallMultipart('/rpc/plm/data-import/import-data-to-products', [file, operationType, updateProductsInSeasonData, seasonId]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.DataImport';
metadata.__type_short__ = 'DataImport';
DataImport.prototype.__metadata__ = metadata;

DataImport.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/DataImport */
export default DataImport

export { DataImport }
